import React, { useMemo, useEffect, useRef } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDoctorDegree } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const DoctorDegreeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
}) => {
  const isInitialMount = useRef(true);

  const degreeName = rowData?.degree_name
    ? rowData.degree_name
    : rowData?.degree_obj?.degree
    ? rowData.degree_obj.degree
    : getValues().degree_name;

  const selectedDegree = watch("doctor_degree_id");

  const {
    data: degrees,
    isLoading,
    error,
  } = useQuery(["degrees"], () => fetchDoctorDegree(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const modifiedData = useMemo(() => {
    return (
      degrees?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.degree_name,
      })) || []
    );
  }, [degrees]);

  const selectedOption = useMemo(() => {
    return (
      modifiedData.find((option) => option.value === selectedDegree) ||
      modifiedData.find((option) => option.label === degreeName) ||
      null
    );
  }, [modifiedData, selectedDegree, degreeName]);

  // Sirf rowData change hone par SET karo
  useEffect(() => {
    if (rowData?.doctor_degree_id && modifiedData.length > 0) {
      const rowDataOption = modifiedData.find(
        (option) => option.value === rowData.doctor_degree_id
      );
      if (rowDataOption) {
        setValue("doctor_degree_id", rowDataOption.value, {
          shouldValidate: false,
        });
        setValue("degree_name", rowDataOption.label, { shouldValidate: false });
      }
    }
  }, [rowData?.doctor_degree_id, modifiedData.length]); // Specific dependencies

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Doctor's Degree</div>;

  return (
    <Controller
      name="doctor_degree_id"
      control={control}
      rules={{ required: "Degree is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={modifiedData}
          isClearable
          value={selectedOption || null}
          placeholder="Select Doctor's Degree"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            const label = selectedOption ? selectedOption.label : "";

            field.onChange(value);
            setValue("degree_name", label, { shouldValidate: false });
          }}
          className={`react-select-container ${
            errors.doctor_degree_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default DoctorDegreeDropdown;
